export const ZEFFY_MAIN = "https://www.zeffy.com/en-US/donation-form/donate-to-change-lives-17387";
export const ZEFFY_SPIKE = "https://www.zeffy.com/en-US/donation-form/spikes-eye-surgery";
export const PAYPAL_DONATE = "https://www.paypal.com/ncp/payment/24ZFTZCJ5M8JE";
export const PAYPAL_CLIENT_ID = "BAAntDIqCGH8pp9QY2A8BNlFzfZr8ib0H9vJ2h4Naqz3lB67aV4aTwwZYgwaHbldE_lnFD9RZhWLjxK5PI";
export const PAYPAL_HOSTED_BUTTON_ID = "24ZFTZCJ5M8JE";
export const VENMO_URL = "https://www.venmo.com/u/lavish808buliiezrescuedpaws";
export const SHOPIFY_URL = "https://lavish808bulliezrescuedpaws-shop.myshopify.com/";

export const CONTACT = {
  org: "Lavish 808 Bulliez Rescued Paws",
  motto: "Every Paw Deserves a Second Chance at a Lavish Life",
  tagline: "Saving Lives Through Aloha, Compassion & Community",
  address: "39525 Los Alamos Rd Ste C, Murrieta CA 92563",
  ein: "42-3174937",
  phone: "808-450-4960",
  email: "info@lavish808buliezrescuedpaws.org",
  facebook: "https://facebook.com/Lavish808bulliezrescuedpaws",
  instagram: "https://instagram.com/lavish808buliezrescuedpaws",
  hours: [
    { day: "Mon – Fri", time: "9am – 5pm" },
    { day: "Saturday", time: "10am – 3pm" },
    { day: "Sunday", time: "Closed" },
  ],
};

export const HERO_VIDEO = "https://videos.pexels.com/video-files/6568618/6568618-hd_1920_1080_25fps.mp4";
export const HERO_VIDEO_FALLBACK = "https://videos.pexels.com/video-files/4587951/4587951-hd_1920_1080_30fps.mp4";
export const HERO_POSTER = "https://images.unsplash.com/photo-1587893143314-972249555d65?w=1600&q=80";
